import { Reducer } from "redux";

import { NoMNCDocumentDetails } from "../models/api/Referral";
import { NoMncDetailsDispatchTypes } from "../models/dispatchTypes/Referral";
import { NoMncDetailsActionDispatchTypes } from "../constants/Referral";

const initialState: NoMNCDocumentDetails = {
  loading: false,
  response: false,
  error: null,
};

const PutNOMNCDocDetailsReducer: Reducer<
NoMNCDocumentDetails,
NoMncDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case NoMncDetailsActionDispatchTypes.NO_MNC_DOCUMENT_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case NoMncDetailsActionDispatchTypes.NO_MNC_DOCUMENT_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case NoMncDetailsActionDispatchTypes.NO_MNC_DOCUMENT_DETAILS_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case NoMncDetailsActionDispatchTypes.NO_MNC_DOCUMENT_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PutNOMNCDocDetailsReducer;
